// extracted by mini-css-extract-plugin
export var menuIcon = "_pi-0";
export var menuIconInline = "_pi-1";